(ns ui.view.counterparty-diligence.responder-form.validation-error-text
  (:require
   [common.util :as cu]
   [clojure.string :as string]
   [common.localization :as loc]))

(defn view
  [{:keys [validation-errors]}]
  (let [error-text (cond
                     (cu/empty-value? validation-errors)
                     ""

                     (string? validation-errors)
                     validation-errors

                     (keyword? validation-errors)
                     (loc/tr validation-errors)

                     (map? validation-errors)
                     (str validation-errors)

                     (sequential? validation-errors)
                     (->> validation-errors
                          (mapv (fn [error]
                                  (if (keyword? error)
                                    (loc/tr error)
                                    (str error))))
                          (string/join ", "))

                     :else "")
        error-text (string/trim error-text)]
    (when-not (cu/blank-value? error-text)
      [:p
       {:class "text-sm m-0 text-danger-regular"}
       error-text])))
